import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { queryTeacherAdminDetail, editAdminDetail } from '@/api'
import { Message } from 'element-ui'
@Component({ name: 'MainTutorDetail', components: { HighFilter } })
export default class MainTutorDetail extends Vue {
  private detailObi: any = {
    detail: ''
  }

  private teacherId: any = null
  private evaluationVisible: any = false
  private evaluationObj: any = {
    evaluation: ''
  }

  private editType: any = '' // 1修改，2查看详情
  private mainTeacherDetail: any = {}
  private tableData2: any = []

  created () {
    this.editType = this.$route.query.type
    this.teacherId = this.$route.query.id
    this.adminDetail()
  }

  private async adminDetail () {
    const result: any = await queryTeacherAdminDetail({ id: this.teacherId })
    this.mainTeacherDetail = result
    this.tableData2 = result.teacherInfoList
  }

  private async updateEvaluation () {
    this.evaluationObj.id = this.teacherId
    const { error }: any = await editAdminDetail(this.evaluationObj)
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      this.evaluationVisible = false
      this.adminDetail()
    }
  }

  private async lookRow (row: any) {
    this.$router.push({ path: '/student/schedule', query: { teacherId: this.teacherId, teacherName: this.mainTeacherDetail.realName, lookType: '3' } })
  }
}
